module.exports = __webpack_public_path__ + "img/third-place.15158611.png";